import React, { useState } from 'react';
import ProjectSidebar from './ProjectSidebar';
import TaskListView from './TaskListView';
import BoardView from './BoardView';
import useStore from '../../utils/store';

import { useWorkspaces } from '../../hooks/useWorkspaces';

const TasksLayout = ({ auth }) => {
    const workspaceId = useStore(state => state.workspaceId);
    const [selectedView, setSelectedView] = useState(null); // { type: 'project'|'board', data: ... }

    // Fetch members
    const { getMembers } = useWorkspaces({ token: auth?.user?.access_token });
    const [members, setMembers] = useState([]);

    React.useEffect(() => {
        if (workspaceId) {
            getMembers(workspaceId).then(data => {
                if (data) setMembers(data);
            });
        }
    }, [workspaceId]);

    const [showMobileSidebar, setShowMobileSidebar] = useState(false);
    const handleCloseMobileSidebar = () => setShowMobileSidebar(false);
    const handleToggleMobileSidebar = () => setShowMobileSidebar(true);

    // Filter project updates to close mobile sidebar on selection
    const handleSelectView = (view) => {
        setSelectedView(view);
        handleCloseMobileSidebar();
    };

    return (
        <div className="d-flex h-100 w-100 overflow-hidden" style={{ height: 'calc(100vh - 60px)' }}>
            {/* Desktop Sidebar */}
            <div className="d-none d-md-block h-100 border-end" style={{ width: '250px', minWidth: '250px' }}>
                <ProjectSidebar
                    auth={auth}
                    workspaceId={workspaceId}
                    onSelectView={setSelectedView}
                    selectedView={selectedView}
                />
            </div>

            {/* Mobile Sidebar (Offcanvas) */}
            <div className="d-md-none">
                <div
                    className={`offcanvas offcanvas-start ${showMobileSidebar ? 'show' : ''}`}
                    tabIndex="-1"
                    style={{ visibility: showMobileSidebar ? 'visible' : 'hidden' }}
                >
                    <div className="offcanvas-header border-bottom">
                        <h5 className="offcanvas-title">Menu</h5>
                        <button type="button" className="btn-close text-reset" onClick={handleCloseMobileSidebar}></button>
                    </div>
                    <div className="offcanvas-body p-0">
                        <ProjectSidebar
                            auth={auth}
                            workspaceId={workspaceId}
                            onSelectView={handleSelectView}
                            selectedView={selectedView}
                            isMobile={true}
                        />
                    </div>
                </div>
                {/* Backdrop for custom offcanvas if needed, but Bootstrap classes normally handle it if using the component. 
                    However, here we are manually using classes. Let's use the Component if possible, but the original file didn't import Offcanvas.
                    Let's check imports.
                */}
            </div>
            {showMobileSidebar && <div className="offcanvas-backdrop fade show d-md-none" onClick={handleCloseMobileSidebar}></div>}

            <div className="flex-grow-1 h-100 bg-white w-100">
                {selectedView?.type === 'board' ? (
                    <BoardView
                        auth={auth}
                        workspaceId={workspaceId}
                        board={selectedView.data}
                        onToggleSidebar={handleToggleMobileSidebar}
                        members={members}
                    />
                ) : (
                    <TaskListView
                        auth={auth}
                        workspaceId={workspaceId}
                        selectedView={selectedView}
                        onToggleSidebar={handleToggleMobileSidebar}
                        members={members}
                    />
                )}
            </div>
        </div>
    );
};

export default TasksLayout;
